import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import FragmentCardContent from "./FragmentCardContent";
import { useNavigate } from "react-router";
import { getImagesUrl } from "../../redux/common";

export interface ElementErrorProps {
  error?: React.ReactNode;
  retry?: () => void;
}
const FragmentCardError = ({ error, retry }: ElementErrorProps) => {
  const navigate = useNavigate();

  return <FragmentCardContent
      image={`${getImagesUrl()}/error.webp`}
      title='Erro ao processar solicitação'
      description={
          <Box>
            <Typography sx={{ p: "10px", m: "10px" }}>
              {error || "Erro ao processar solicitação. Por favor, tente novamente ou contate o administrador."}
            </Typography>
            <ButtonGroup variant="outlined" color="secondary" size="small">
              <Button onClick={() => { navigate(-1); }}>Voltar</Button>
              { retry && <Button onClick={() => { retry(); }}>Atualizar</Button> }
              <Button onClick={() => { navigate("/"); }}>Inicio</Button>
            </ButtonGroup>
          </Box>
      }
    />;
};

export default FragmentCardError;